import { Platform, AppState, AppStateStatus } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage'
import {createClient} from '@supabase/supabase-js';

const supabaseUrl = 'https://hedplceewqjrmrpxblnk.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhlZHBsY2Vld3Fqcm1ycHhibG5rIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA3NTY5MzMsImV4cCI6MjA2NjMzMjkzM30.8V6gOcMJFJBNRGtnwuQjnSW4PKzSgw42yknwSXQN1ek';

// Create a custom storage adapter that handles potential AsyncStorage issues
const customStorage = {
  getItem: async (key: string): Promise<string | null> => {
    try {
      // Check if AsyncStorage is available
      if (AsyncStorage && typeof AsyncStorage.getItem === 'function') {
        return await AsyncStorage.getItem(key);
      }
      // Fallback to localStorage for web
      if (typeof (globalThis as any).window !== 'undefined' && (globalThis as any).window.localStorage) {
        return (globalThis as any).window.localStorage.getItem(key);
      }
      return null;
    } catch (error) {
      console.warn('Storage getItem error:', error);
      // Fallback to localStorage for web
      try {
        if (typeof (globalThis as any).window !== 'undefined' && (globalThis as any).window.localStorage) {
          return (globalThis as any).window.localStorage.getItem(key);
        }
      } catch (e) {
        // Ignore fallback errors
      }
      return null;
    }
  },
  setItem: async (key: string, value: string): Promise<void> => {
    try {
      // Check if AsyncStorage is available
      if (AsyncStorage && typeof AsyncStorage.setItem === 'function') {
        await AsyncStorage.setItem(key, value);
        return;
      }
      // Fallback to localStorage for web
      if (typeof (globalThis as any).window !== 'undefined' && (globalThis as any).window.localStorage) {
        (globalThis as any).window.localStorage.setItem(key, value);
      }
    } catch (error) {
      console.warn('Storage setItem error:', error);
      // Fallback to localStorage for web
      try {
        if (typeof (globalThis as any).window !== 'undefined' && (globalThis as any).window.localStorage) {
          (globalThis as any).window.localStorage.setItem(key, value);
        }
      } catch (e) {
        // Ignore fallback errors
      }
    }
  },
  removeItem: async (key: string): Promise<void> => {
    try {
      // Check if AsyncStorage is available
      if (AsyncStorage && typeof AsyncStorage.removeItem === 'function') {
        await AsyncStorage.removeItem(key);
        return;
      }
      // Fallback to localStorage for web
      if (typeof (globalThis as any).window !== 'undefined' && (globalThis as any).window.localStorage) {
        (globalThis as any).window.localStorage.removeItem(key);
      }
    } catch (error) {
      console.warn('Storage removeItem error:', error);
      // Fallback to localStorage for web
      try {
        if (typeof (globalThis as any).window !== 'undefined' && (globalThis as any).window.localStorage) {
          (globalThis as any).window.localStorage.removeItem(key);
        }
      } catch (e) {
        // Ignore fallback errors
      }
    }
  }
};

export const Supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: customStorage,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,
  },
});

export default Supabase;

// Handle AppState changes for auth token refresh
// Works on both React Native and React Native Web
if (Platform.OS !== 'web' && AppState && typeof AppState.addEventListener === 'function') {
  const subscription = AppState.addEventListener('change', (state: AppStateStatus) => {
  if (state === 'active') {
      Supabase.auth.startAutoRefresh();
  } else {
      Supabase.auth.stopAutoRefresh();
  }
  });
} else if (Platform.OS === 'web' && typeof (globalThis as any).window !== 'undefined') {
  // On web, use window focus/blur events for token refresh
  const handleFocus = () => {
    Supabase.auth.startAutoRefresh();
  };
  const handleBlur = () => {
    Supabase.auth.stopAutoRefresh();
  };
  (globalThis as any).window.addEventListener('focus', handleFocus);
  (globalThis as any).window.addEventListener('blur', handleBlur);
  
  // Cleanup
  (globalThis as any).window.addEventListener('beforeunload', () => {
    (globalThis as any).window.removeEventListener('focus', handleFocus);
    (globalThis as any).window.removeEventListener('blur', handleBlur);
  });
}
